import watchGetFAQDataRequested from './getFAQDataSaga';

export default [
  watchGetFAQDataRequested(),
];
